import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Radio, Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const MultiplePrintModal = ({
  openPrintModal,
  setOpenPrintModal,
  printContract,
  sendContract,
  action,
  form,
  contract
}) => {
  const { t } = useTranslation();
  const blockedInsuranceCertificate = [
    'UNPAID_1',
    'UNPAID_2',
    'UNPAID_3',
    'FORMAL_NOTICE'
  ];
  const [visible, setVisible] = useState(false);
  const onChange = () => {
    setVisible(false);
  };
  const Amendments = () => {
    const result = [];
    for (let i = 0; i < contract?.amendment?.length; i += 1) {
      result.unshift(
        <Col span={24}>
          <Radio value={`amendment_${i}`}>
            {`${t('contracts.form.print_amendment')} ${i + 1}`}
          </Radio>
        </Col>
      );
    }
    return result.map((i) => i);
  };
  const QuittancesYears = () => {
    let result = [];
    for (let i = 0; i < contract?.quittances?.length; i += 1) {
      const year = moment(contract.quittances[i].period_date).year();
      result.push(year);
    }
    result.sort((a, b) => a.timeM - b.timeM);
    result = [...new Set(result)];
    const results = [];
    for (let i = 0; i < result.length; i += 1) {
      results.push(
        <Row span={24}>
          <Radio value={result[i]}>{result[i]}</Radio>
        </Row>
      );
    }
    return results.map((i) => i);
  };

  return (
    <>
      <Modal
        title={t(`contracts.modal.title_${action}`)}
        centered
        style={{ top: 20 }}
        open={openPrintModal}
        onCancel={() => {
          setOpenPrintModal(false);
          form.resetFields();
        }}
        width={550}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            <Button
              onClick={() => {
                if (action === 'send') {
                  sendContract();
                } else {
                  printContract();
                }
                setOpenPrintModal(false);
              }}
              type="primary"
              style={{
                width: 'auto',
                padding: '4px 15px'
              }}
            >
              {t('buttons.validate_print')}
            </Button>
          </div>
        ]}
      >
        <Form form={form}>
          <Form.Item name="documents">
            <Radio.Group>
              <Row>
                {contract && contract?.amendment ? <Amendments /> : <></>}
                <Col span={24}>
                  <Radio value="contract" onChange={onChange}>
                    {t('contracts.form.print_contract')}
                  </Radio>
                </Col>
                <Col span={24}>
                  <Radio value="paymentSchedule" onChange={onChange}>
                    {`${t(
                      `contracts.form.print_${
                        contract && contract.payment_type === 'DIRECTDEBIT'
                          ? 'paymentSchedule'
                          : 'timescale'
                      }`
                    )}`}
                  </Radio>
                </Col>
                {blockedInsuranceCertificate.includes(contract.status) ? (
                  []
                ) : (
                  <Col span={24}>
                    <Radio value="insuranceCertificate" onChange={onChange}>
                      {t('contracts.form.print_insuranceCertificate')}
                    </Radio>
                  </Col>
                )}
                {contract?.type === 'RCP' &&
                  !blockedInsuranceCertificate.includes(contract.status) && (
                    <Col span={24}>
                      <Radio
                        value="insuranceCertificate_wt"
                        onChange={onChange}
                      >
                        {t(
                          'contracts.form.print_insuranceCertificate_without_table'
                        )}
                      </Radio>
                    </Col>
                  )}
                <Col span={24}>
                  <Radio
                    value="quittancesPaid"
                    onChange={() => setVisible(true)}
                  >
                    {t('contracts.form.print_quittancesPaid')}
                    {contract && contract?.quittances && visible ? (
                      // <Form form={form}>
                      <Form.Item name="quittancesPaid_date">
                        <Radio.Group
                          style={{ overflow: 'scroll', maxHeight: '200px' }}
                        >
                          <Space orientation="vertical">
                            <QuittancesYears />
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    ) : (
                      // </Form>
                      <></>
                    )}
                  </Radio>
                </Col>
                {contract && contract.payment_type === 'DIRECTDEBIT' && (
                  <Col span={24}>
                    <Radio value="sepa" onChange={onChange}>
                      {t('contracts.form.print_sepa')}
                    </Radio>
                  </Col>
                )}
              </Row>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

MultiplePrintModal.propTypes = {
  openPrintModal: PropTypes.bool.isRequired,
  setOpenPrintModal: PropTypes.func.isRequired,
  printContract: PropTypes.func.isRequired,
  sendContract: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  contract: PropTypes.shape({
    amendment: PropTypes.arrayOf(PropTypes.string),
    payment_type: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
    quittances: PropTypes.string
  }).isRequired,
  form: PropTypes.shape({
    resetFields: PropTypes.func
  }).isRequired
};

export default MultiplePrintModal;
